import React, { FC } from "react";

type Props = {
  selectedCategory: string;
};

const FilterCategorySelected: FC<Props> = ({ selectedCategory }) => {
  return (
    <div className="FilterCategorySelected">
      <p className="text-base text-black font-semibold">{selectedCategory}</p>
    </div>
  );
};

export default FilterCategorySelected;
